/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import PageLayout from "customComponents/LayoutContainers/PageLayout";
import Footer from "customComponents/Footer";
import MDReport from "./MDReport";
import AttendenceDialog from "../report/components/attendanceDialog";

function EmployeeReport() {
  const [isLinkExpired, setLinkExpired] = useState(false);
  const [attendanceDialog, setAttendanceDialog] = useState(null);

  const { token } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const period = searchParams.get("period");

  const openAttendanceDialog = (data) => {
    setAttendanceDialog(data);
  };

  const closeAttendanceDialog = () => {
    setAttendanceDialog(null);
  };

  return (
    <PageLayout>
      <MDBox p={2} width="100%" height="100vh" mx="auto">
        {isLinkExpired && (
          <MDBox display="flex" flexDirection="column" flex={1} alignItems="center">
            <MDTypography variant="medium" color="text">
              This link has expired.
            </MDTypography>
          </MDBox>
        )}

        {token && !isLinkExpired && (
          <MDReport
            token={token}
            initialPeriod={period ?? "CURRENT_DAY"}
            onLinkExpired={(bool) => setLinkExpired(bool)}
            onSetPeriod={(newPeriod) => setSearchParams({ period: newPeriod })}
            onSetAttendanceDialog={openAttendanceDialog}
          />
        )}
      </MDBox>

      {attendanceDialog && (
        <AttendenceDialog
          open={Boolean(attendanceDialog)}
          data={attendanceDialog}
          onClose={closeAttendanceDialog}
        />
      )}

      <Footer />
    </PageLayout>
  );
}

export default EmployeeReport;
